import { TaskStatusOption } from "../interface";

export const taskStatusOptions = [
  TaskStatusOption.TODO,
  TaskStatusOption.INPROGRESS,
  TaskStatusOption.COMPLETED,
];
